const initialState = {
  genreList: [],
  searchValue: "",
  numChannels: "",
  hdChannels: "",
  channels: [],
  results: [],
  title: "",
  location: "",
  active: "alpha",
  loaded: false,
  detailModal: "none",
  lfanames: [],
  selectedPkgs: [],
  searchDropdown: [],
  channelProgramResults: [],
  selectedChannelPrograms: [],
  vhoList: [],
  comparePackages: [],
  loading: false,
  maultiple: false,
  countySelected: ""
};
function channelLineup(state = initialState, action) {
  switch (action.type) {
    case "INITALCHANNELLINEUP":
      return Object.assign({}, state, {
        genreList: action.value.genreList,
        numChannels: action.value.numChannels,
        hdChannels: action.value.hdChannels,
        channels: action.value.channels,
        results: action.value.results,
        title: action.value.title,
        location: action.value.location,
        active: action.value.active,
        loaded: action.value.loaded,
        comparePackages: action.value.comparePackages
      });
    case "SETDETAILMODELNONE":
      return Object.assign({}, state, {
        detailModal: action.value
      });
    case "SETTVDETAILMODELID":
      return Object.assign({}, state, {
        detailModal: action.value
      });
    case "CLEARCHANNELRESULTS":
      return Object.assign({}, state, {
        genreList: [],
        numChannels: "",
        hdChannels: "",
        channels: [],
        results: [],
        title: "",
        location: "",
        active: "alpha",
        loaded: false,
        comparePackages: []
      });
    case "SEARCHANNELTEXT":
      return Object.assign({}, state, {
        searchValue: action.value
      });
    case "CHANNELRESULTS":
      return Object.assign({}, state, {
        results: action.value
      });
    case "CHANNELRESULTSUPDATE":
      return Object.assign({}, state, {
        results: action.value.results,
        active: action.value.active
      });
    case "SEARCHVALUEEMPTY":
      return Object.assign({}, state, {
        searchValue: action.value
      });
    case "SETCLUDISPLAY":
      return Object.assign({}, state, {
        cluDisplay: action.value
      });
    case "SETPACKAGES":
      return Object.assign({}, state, {
        packageList: action.value.packageList
      });
    case "CLUMESSAGE":
      return Object.assign({}, state, {
        message: action.value
      });
    case "UPDATESELECTEDPKGS":
      return Object.assign({}, state, {
        selectedPkgs: action.value
      });
    case "SETSEARCHDROPDOWN":
      return Object.assign({}, state, {
        searchDropdown: action.value.searchDropdown
      });
    case "SETCHANNELPROGRAMRESULTS":
      return Object.assign({}, state, {
        channelProgramResults: action.value.channelProgramResults
      });
    case "SETSELECTEDCHANNELPROGRAMS":
      return Object.assign({}, state, {
        selectedChannelPrograms: action.value
      });
    case "ZIPCHANGE":
      return Object.assign({}, state, {
        vhoList: action.value.vhoList,
        multiple: action.value.multiple,
        loading: action.value.loading
      });
    case "COUNTYSELECTED":
      return Object.assign({}, state, {
        countySelected: action.value.countySelected,
        multiple: action.value.multiple
      });
    default:
      return state;
  }
}
export default channelLineup;
